// extracted by mini-css-extract-plugin
export default {"app-market-page":"_jx5kxv","appMarketPage":"_jx5kxv","app-market-page-background-color":"_1geg21a","appMarketPageBackgroundColor":"_1geg21a"};